import { SerializableObject } from '../../common-react/core';

import { Currency } from '../other/currency.type';
import { WeightUnit } from './parcel.do';

/**
 * Information on Customs handling of an item.
 */
export class CustomsItem extends SerializableObject {
	public cost: number;
	public currencyCode: Currency;
	public description?: string;
	/**
	 * Harmonized System (HS) Tariff Code, e.g. "0804.30.10". See this Wiki article for more details on this coding standard:
	 *
	 * @see https://en.wikipedia.org/wiki/Harmonized_System
	 */
	public hsTariffCode: string;
	public quantity: number;
	public countryOfOrigin: string;
	/** Net weight of the line, in `weightUnit`. */
	public weight?: number;
	/** Unit of `weight`. */
	public weightUnit?: WeightUnit;
}
